module.exports = __webpack_public_path__ + "img/4064005760.216b6821.jpg";